const Download = () => {
    return (
        <>
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M14 2H6C4.9 2 4.01 2.9 4.01 4L4 20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM18 20H6V4H13V9H18V20Z"
                    fill="black"
                />
                <path
                    d="M13 15.16L13.8839 14.2817C14.2742 13.8938 14.9048 13.8948 15.2939 14.2839C15.6839 14.6739 15.6839 15.3061 15.2939 15.6961L12.6989 18.2911C12.3077 18.6823 11.6731 18.6815 11.2829 18.2894L8.70109 15.6946C8.31321 15.3048 8.31414 14.6736 8.70163 14.2834C9.09174 13.8905 9.72811 13.8881 10.1196 14.2796L11 15.16V12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12V15.16Z"
                    fill="black"
                />
            </svg>
        </>
    )
}

export default Download;